import { createEvent, restore, sample } from 'effector'
import { libraryGridPurchasedLiveEventsWidget } from '~/widgets/library/grid/purchased/liveEvents'

export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

sample({
  clock: libraryGridPurchasedLiveEventsWidget.$isGridPurchasedLiveEventsLoading,
  target: setContentLoading,
})
